import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/PageNotFound.module.css';

const propTypes = {
  location: PropTypes.object.isRequired,
};


export default function PageNotFound({ location }) {
  return (
    <div className={styles.Main}>
        <div className={styles.Box}>
            <p className={styles.P}>
            Stran, ki ste jo iščete - <strong>{location.pathname}</strong>, ne obstaja.
            Ne ujema se z nobenimi "React Router routes".
            </p>
        </div>
    </div>
  );
}

PageNotFound.propTypes = propTypes;